import Icon from '@mui/icons-material/Save';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function SaveIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
